export enum GetAttachmentMode {
  UNSET_MODE = 'UNSET_MODE',
  ATTACHMENT_UPLOAD = 'ATTACHMENT_UPLOAD',
  ATTACHMENT_DOWNLOAD = 'ATTACHMENT_DOWNLOAD',
}
